module.exports = __webpack_public_path__ + "img/upload.65ad294c.svg";